import React from "react";
import { Link } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import { BY_KEY, FOOTER_GROUPS } from "../../config/siteRegistry";

// Footer links come from the site registry, so every hub is one crawlable
// <a href> away from every page. Internal links use the router (no reload).
const menuItems = FOOTER_GROUPS.map((group) => ({
  name: group.name,
  items: [
    ...group.keys.map((k) => ({ label: BY_KEY[k].navLabel, url: BY_KEY[k].href })),
    ...(group.extra || []).map((x) => ({ label: x.label, url: x.href })),
  ],
}));

const FooterLink = ({ item }) =>
  item.url.startsWith('/') ? (
    <Link className="column-item-link" to={item.url}>
      {item.label}
    </Link>
  ) : (
    <a className="column-item-link" href={item.url}>
      {item.label}
    </a>
  );

export const FooterMenu = () => {
  const isMobile = useMediaQuery('(max-width: 749px)');

  return (
    <nav className="footer-menu" aria-label="Site">
      {!isMobile ? (
        <div className="desktop">
          <div className="columns">
            {menuItems.map((group) => (
              <div className="column" key={group.name}>
                <p className="column-name">{group.name}</p>
                <ul className="column-items">
                  {group.items.map((item) => (
                    <li className="column-item" key={item.url}>
                      <FooterLink item={item} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="mobile">
          <ul className="column-items" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: 16 }}>
            {menuItems.flatMap((group) => group.items).map((item) => (
              <li className="column-item" key={item.url}>
                <FooterLink item={item} />
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};
